import React from "react";
import { Mail, ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";
import { useLang } from "../contexts/LangContext";
import { PageHeader } from "./Formats";

export default function Careers() {
  const { t } = useLang();
  return (
    <div data-testid="careers-page">
      <PageHeader eyebrow={t.careers.eyebrow} title={t.careers.title} subtitle={t.careers.body} />
      <section className="bg-[#0a0a0a] pb-32">
        <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-10">
          <Reveal className="lg:col-span-7">
            <div className="space-y-4">
              {[
                { t: "Operatori cucina mobile", d: "Esperienza in food truck, street food o ristorazione veloce." },
                { t: "Capi area / coordinatori on-site", d: "Capacità organizzativa, gestione di team in eventi affollati." },
                { t: "Personale di sala / sushi bar", d: "Eleganza, velocità e attitudine al servizio premium." },
                { t: "Logistica e supporto operativo", d: "Allestimenti, mezzi e supply chain sul campo." },
              ].map((r, i) => (
                <div key={i} className="border border-white/10 p-7 hover:border-[color:var(--gold)]/60 transition-colors" data-testid={`careers-role-${i}`}>
                  <div className="flex items-center gap-4">
                    <span className="font-display tabular-nums text-2xl text-[color:var(--gold)] w-12">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div>
                      <div className="h3 text-white">{r.t}</div>
                      <p className="text-[color:var(--txt-secondary)] mt-1 text-sm">{r.d}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal className="lg:col-span-5" delay={120}>
            <div className="border border-white/10 p-10 sticky top-28">
              <div className="eyebrow mb-3">{t.careers.eyebrow}</div>
              <h3 className="h3 text-white mb-6">Candidatura spontanea</h3>
              <p className="text-[color:var(--txt-secondary)] leading-relaxed">
                Invia il tuo CV e una breve presentazione. Ti ricontatteremo se troviamo un match con i nostri progetti.
              </p>
              <a
                href="mailto:scudierigroup@gmail.com?subject=Candidatura%20spontanea%20-%20Scudieri%20Group"
                className="btn-primary mt-8"
                data-testid="careers-apply"
              >
                <Mail className="w-4 h-4" /> {t.careers.cta} <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
